/**
 * /financeiro/cadastros — Cadastros financeiros (ADR-0028) · redesign FIN-7.
 *
 * Fiel ao mockup Fase 5 V2.2 (#cadastros): shell .fin2 com tabchips e 4 abas
 * (Contas em cards, Categorias em chips agrupados, Centros e Condições em
 * tabelas). Camada visual; CRUD e endpoints inalterados.
 */
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { PageContainer } from "../../../styles/shared";

import ContasTab from "./ContasTab";
import CategoriasTab from "./CategoriasTab";
import CentrosTab from "./CentrosTab";
import CondicoesTab from "./CondicoesTab";


const TABS = [
  { id: "contas", label: "Contas bancárias" },
  { id: "categorias", label: "Categorias" },
  { id: "centros", label: "Centros de custo" },
  { id: "condicoes", label: "Condições de pagamento" },
];


export default function Cadastros() {
  // `?aba=categorias` abre direto a aba (links da lista "Configure sua empresa").
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(() => {
    const pedida = searchParams.get("aba");
    return TABS.some((t) => t.id === pedida) ? pedida : "contas";
  });

  return (
    <PageContainer style={{ maxWidth: "none" }} className="fin2">
      <div style={{ marginBottom: 18 }}>
        <div className="breadcrumb">
          <span>Início</span><span className="crumb-sep">/</span>
          <span>Financeiro</span><span className="crumb-sep">/</span>
          <span className="active">Cadastros</span>
        </div>
        <h1 className="page-title">Cadastros financeiros</h1>
        <div className="page-sub">Contas, categorias, centros de custo e condições de pagamento</div>
      </div>

      <div className="tabchip-group" style={{ marginBottom: 16 }}>
        {TABS.map((t) => (
          <div key={t.id} className={"tabchip" + (tab === t.id ? " active" : "")}
               role="button" tabIndex={0} onClick={() => setTab(t.id)}
               onKeyDown={(e) => e.key === "Enter" && setTab(t.id)}>{t.label}</div>
        ))}
      </div>

      {tab === "contas" && <ContasTab />}
      {tab === "categorias" && <CategoriasTab />}
      {tab === "centros" && <CentrosTab />}
      {tab === "condicoes" && <CondicoesTab />}
    </PageContainer>
  );
}
